/**
 * Radix Floating(SPopover/STooltip/RTooltip) Content 의 placement 방향별 슬라이드+페이드.
 * Radix 가 붙이는 data-side(실제 렌더 방향)·data-state 에 맞춰 열림/닫힘 애니메이션을 적용한다.
 * (sd-floating-portal 의 sd-floating-slide-* 포팅 — 키프레임은 theme.css `--animate-floating-*`)
 *
 * 예: side=top 이면 아래(4px)에서 위로 올라오며 나타나고, 닫힐 때 다시 내려가며 사라진다.
 *
 * @radix-ui/react-popover · react-dropdown-menu 의 data-state 는 open/closed 지만,
 * @radix-ui/react-tooltip 은 open 대신 delayed-open/instant-open 을 쓴다 — 두 케이스 모두 커버한다.
 * Tailwind JIT는 소스에 리터럴로 등장하는 클래스명만 스캔하므로 템플릿으로 조합하지 않고 전부 나열한다.
 */
export const FLOATING_SLIDE_ANIM = [
  'data-[state=open]:data-[side=top]:animate-floating-in-top',
  'data-[state=delayed-open]:data-[side=top]:animate-floating-in-top',
  'data-[state=instant-open]:data-[side=top]:animate-floating-in-top',
  'data-[state=closed]:data-[side=top]:animate-floating-out-top',
  'data-[state=open]:data-[side=bottom]:animate-floating-in-bottom',
  'data-[state=delayed-open]:data-[side=bottom]:animate-floating-in-bottom',
  'data-[state=instant-open]:data-[side=bottom]:animate-floating-in-bottom',
  'data-[state=closed]:data-[side=bottom]:animate-floating-out-bottom',
  'data-[state=open]:data-[side=left]:animate-floating-in-left',
  'data-[state=delayed-open]:data-[side=left]:animate-floating-in-left',
  'data-[state=instant-open]:data-[side=left]:animate-floating-in-left',
  'data-[state=closed]:data-[side=left]:animate-floating-out-left',
  'data-[state=open]:data-[side=right]:animate-floating-in-right',
  'data-[state=delayed-open]:data-[side=right]:animate-floating-in-right',
  'data-[state=instant-open]:data-[side=right]:animate-floating-in-right',
  'data-[state=closed]:data-[side=right]:animate-floating-out-right',
].join(' ');
